// src/lang/langcontext/LanguageContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import en from "../translations/en.json";
import mr from "../translations/mr.json";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState("en");
    const [translations, setTranslations] = useState(language === "en" ? en : mr);

    // Update translations when language changes
    useEffect(() => {
        if (language === "en") setTranslations(en);
        else setTranslations(mr);

        localStorage.setItem("language", language);
        translatePage(language === "en" ? en : mr);
    }, [language]);

    // Toggle between English & Marathi
    const toggleLanguage = (lang) => {
        setLanguage(lang);
    };

    // Core translation helper (if you need it manually anywhere)
    const t = (key) => translations[key] || key;

    // 🔥 Automatic DOM-based translation
    const translatePage = (currentTranslations) => {

        const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);

        let node;
        while ((node = walker.nextNode())) {
            const text = node.textContent.trim();
            if (text && currentTranslations[text]) {
                node.textContent = currentTranslations[text];
            }
        }
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

// Hook for easy access
export const useLanguage = () => useContext(LanguageContext);
